///
/// EarthBrowser
///
/// Created by Matt Giger on 10/23/2026
/// Copyright (c) 2026 Geodata Labs
///
/// Top-left chrome cluster: the Layers launcher (what's on the globe) and
/// the Search launcher (⌘K palette). Hidden while the Layers panel is
/// open - on desktop the panel occupies this corner, and it carries its
/// own ⌘K handoff.
///

import { LayersButton } from "@/components/controls/layers-panel/LayersPanel"
import { SearchButton } from "@/components/controls/search/CommandPalette"
import { useIsMobile } from "@/components/utils/use-mobile"
import { useAppSelector } from "@/redux/store"

export function TopLeftControls() {
	const isMobile = useIsMobile()
	const layersOpen = useAppSelector(state => state.dialog.layersPanelOpen)

	if (layersOpen) return null

	return (
		<div
			className="fixed z-[900] flex items-center gap-2"
			style={{
				// Same 8px inset as the top-right cluster so the top row lines up
				top: "calc(0.5rem + var(--safe-area-inset-top))",
				left: "calc(0.5rem + var(--safe-area-inset-left))",
			}}
		>
			<LayersButton />
			<SearchButton isMobile={isMobile} />
		</div>
	)
}
